<label
  class="checkbox"
  [class.checked]="checked()"
  [class.disabled]="isDisabled()"
  (click)="toggle()"
>
  <span class="checkbox-box">
    <img src="/assets/icons/check_small.svg" alt="" class="checkbox-icon" [class.visible]="checked()" />
  </span>
  <ng-content />
</label>
